
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);


const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    // 其它页面使用按需加载的形式
    {
        path: '/libHome',
        name: 'libHome',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/libHome.vue'),
        meta: {
            name: '图书馆首页'
        }
    },
    {
        path: '/bookSearch',
        name: 'BookSearch',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/bookSearch.vue'),
        meta: {
            name: '图书检索'
        }
    }, {
        path: '/bookDetail',
        name: 'BookSearchDetail',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/bookSearchDetail.vue'),
        meta: {
            name: '图书详情'
        }
    }, {
        path: '/rank',
        name: 'rank',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/rank.vue'),
        meta: {
            name: '排行榜'
        }
    }, {
        path: '/educate',
        name: 'educate',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/educate.vue'),
        meta: {
            name: '教育专题'
        }
    }, {
        path: '/active',
        name: 'active',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/active.vue'),
        meta: {
            name: '活动专题'
        }
    }, {
        path: '/onlineAnswer',
        name: 'onlineAnswer',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/onlineAnswer.vue'),
        meta: {
            name: '在线问答'
        }
    }, {
        path: '/onlineAssessment',
        name: 'onlineAssessment',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/onlineAssessment.vue'),
        meta: {
            name: '在线测评'
        }
    },
    {
        path: '/information/detail',
        name: 'InformationDetail',
        meta: {
            title: '',
            menuPath: '/information'
        },
        component: () => import(/* webpackChunkName: "informationDetail" */ '../views/informationDetail.vue')
    }, {
        path: '/readBook',
        name: 'readBook',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/readBook.vue'),
        meta: {
            name: '在线阅读'
        }
    }, {
        path: '/culturalTour',
        name: 'culturalTour',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/culturalTour.vue'),
        meta: {
            name: '历史遗存',
            nav: true
        }
    }, {
        path: '/audiovisualLibrary',
        name: 'audiovisualLibrary',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/audiovisualLibrary.vue'),
        meta: {
            name: '影音库',
            nav: true
        }
    }, {
        path: '/travelColumn',
        name: 'travelColumn',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/travelColumn.vue'),
        meta: {
            name: '祖地文旅',
            nav: true
        }
    }, {
        path: '/literatureLecture',
        name: 'literatureLecture',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/literatureLecture.vue'),
        meta: {
            name: '大圣讲堂',
            nav: true
        }
    }, {
        path: '/literatureLecture/detail',
        name: 'zXDetail',
        component: () => import(/* webpackChunkName: "introduction" */ '../views/zXDetail.vue'),
        meta: {
            name: '大圣讲堂',
            nav: true
        }
    },
    {
        path: '/dsCulture',
        name: 'dsCulture',
        component: () => import(/* webpackChunkName: "dsCulture" */ '../views/dsCulture.vue'),
        meta: {
            name: '大圣文化',
            nav: true
        }
    },
    {
        path: '/culturalTourDetail',
        name: 'culturalTourDetail',
        component: () => import(/* webpackChunkName: "culturalTourDetail" */ '../views/culturalTourDetail.vue'),
        meta: {
            name: '庙会庆典',
            nav: true
        }
    },
    // search
    {
        path: '/articleSearch',
        name: 'articleSearch',
        component: () => import(/* webpackChunkName: "articleSearch" */ '../views/articleSearch.vue'),
        meta: {
            name: '查询',
            nav: true
        }
    }
];

const router = new VueRouter({
    routes,
    scrollBehavior (to, from, savedPosition) {
        // 如果有savedPosition，就用它，没有就会是{ x: 0, y: 0 }
        if (savedPosition) {
            return savedPosition;
        }
        // 如果不想保存位置，可以返回falsy值，比如false或者null
        return { x: 0, y: 0 };

    }
});

export default router;
